import {
  animate,
  AUTO_STYLE,
  AnimationTriggerMetadata,
  keyframes,
  style,
  transition,
  trigger
} from '@angular/animations';

/**
 * Réimplémentation locale des deux seules animations que le projet utilisait
 * de la bibliothèque `angular-animations`. Celle-ci n'a jamais été publiée en
 * Ivy : elle dépendait de ngcc, supprimé à partir d'Angular 15.
 *
 * Les keyframes et les durées reprennent à l'identique celles de la
 * bibliothèque d'origine, pour que le rendu reste inchangé.
 */

const DEFAULT_DURATION = 1000;

export function fadeInUpOnEnterAnimation(): AnimationTriggerMetadata {
  return trigger('fadeInUpOnEnter', [
    transition(
      ':enter',
      [
        style({ visibility: 'hidden' }),
        animate(
          '{{duration}}ms {{delay}}ms',
          keyframes([
            style({
              visibility: 'visible',
              opacity: 0,
              transform: 'translate3d(0, {{translate}}, 0)',
              easing: 'ease',
              offset: 0
            }),
            style({ opacity: 1, transform: 'translate3d(0, 0, 0)', easing: 'ease', offset: 1 })
          ])
        )
      ],
      { params: { delay: 0, duration: DEFAULT_DURATION, translate: '100%' } }
    )
  ]);
}

export function rubberBandOnEnterAnimation(): AnimationTriggerMetadata {
  return trigger('rubberBandOnEnter', [
    transition(
      ':enter',
      [
        animate(
          '{{duration}}ms {{delay}}ms',
          keyframes([
            style({ visibility: AUTO_STYLE, transform: 'scale3d(1, 1, 1)', easing: 'ease', offset: 0 }),
            style({ transform: 'scale3d(1.25, 0.75, 1)', easing: 'ease', offset: 0.3 }),
            style({ transform: 'scale3d(0.75, 1.25, 1)', easing: 'ease', offset: 0.4 }),
            style({ transform: 'scale3d(1.15, 0.85, 1)', easing: 'ease', offset: 0.5 }),
            style({ transform: 'scale3d(0.95, 1.05, 1)', easing: 'ease', offset: 0.65 }),
            style({ transform: 'scale3d(1.05, 0.95, 1)', easing: 'ease', offset: 0.75 }),
            style({ transform: 'scale3d(1, 1, 1)', easing: 'ease', offset: 1 })
          ])
        )
      ],
      { params: { delay: 0, duration: DEFAULT_DURATION } }
    )
  ]);
}
